import React from 'react';
import { Outlet } from 'react-router-dom';

interface ProfileRootPageInterface {}

const ProfileRootPage: React.FC<ProfileRootPageInterface> = () => <Outlet />;

export default ProfileRootPage;
